<div class="history">
  @if (campaignHistoryOverrides) {
    <mds-grid
      [storageKey]="'request-history'"
      (gridReady)="onGridReady($event)"
      [minHeight]="'100%'"
      [overrides]="campaignHistoryOverrides"
      [sizeColumnsToFit]="true"
      [themeClass]="'ag-theme-material'"
    ></mds-grid>
  }
</div>
